import { checkStripe } from "../Common/StripeChecker";
import { Section } from "../jobs-flow/Section";

export default{
    init(){
        this.getModal();
        this.createOrUpdatePaymentSubscription();
        this.updateTotalOnForm();
        this.initPagination();
        this.viewDetailsForm();
    },

    getModal() {
        let $this=this;
        $(document).on('click', '#new-payment-subscription, .edit_payment_subscription', function(e) {
            e.preventDefault();
            let data = {
                type: $(this).data('type'),
                id: $(this).data('id') ?? null,
            };

            $('.bb-preloader-container').show();

            checkStripe(() => {
                $.ajax({
                    type: 'post',
                    url: '/payment-subscriptions/get-modal',
                    data: data,
                    success: function(response) {
                        $('.modal-container').html(response);
                        $('.bb-preloader-container').hide();
                        $('#create_payment_subscription').modal('show');
                        Livewire.rescan();
                        $this.updateTax();
                        $this.changeTaxForServiceListners();
                    },
                    error: function(response) {
                        console.log(response);
                        $('.bb-preloader-container').hide();
                    }
                });
            });
        });
    },

    createOrUpdatePaymentSubscription() {
        $('body').on('click', '#create_payment_subscription .create_payment_subscription', (e) => {
            e.preventDefault();
            //let dataForSend = $('#create-payment-subscription').serializeArray();
            let manual_data = {
                customer_id: $('select[name="customer_id"]').val(),
                service: $('select[name="service"]').val(),
                payment_total: $('#payment_total').val(),
                date_start: $('select[name="date"]').val(),
                frequency:  $('select[name="frequency"]').val(),
                details: $('#comments').val(),
                tax: $('#tax_percent').val() ?? null,
                tax_id: $('#tax_id').val() ?? null,
            };

            this.sendSubscriptionData(manual_data, 'create');
        })

        $('body').on('click', '#create_payment_subscription .update_payment_subscription', (e)=> {
            e.preventDefault();

            let manual_data = {
                id: $('#subscription_id').val(),
                customer_id: $('select[name="customer_id"]').val(),
                service: $('select[name="service"]').val(),
                payment_total: $('#payment_total').val(),
                date_start: $('select[name="date"]').val(),
                frequency:  $('select[name="frequency"]').val(),
                details: $('#comments').val(),
                tax: $('#tax_percent').val() ?? null,
                tax_id: $('#tax_id').val() ?? null,
            };

            this.sendSubscriptionData(manual_data, 'edit');
        });
    },

    sendSubscriptionData(data, type) {
        $('.bb-preloader-container').show();
        $.ajax({
            method: 'POST',
            url: '/payment-subscriptions/'+type+'-payment-subscription',
            data: data,
            success: function(response) {
                window.location.reload(true);
            },
            error: function (response) {
                $('.bb-preloader-container').hide();
                console.log('error:', response);
            }
        });
    },

    updateTotalOnForm() {
        $('body').on('input', '#create_payment_subscription #payment_total', (e) => {
            let value = 0;
            if ($('#payment_total').val()>0) {
                value = parseFloat($('#payment_total').val()) ?? 0;
            }
            $('.sub_total_field').text('$' + value.toFixed(2));

            this.updateTax();
            this.updateTotal();
        });
        $('body').on('change', '#create_payment_subscription #service_tax_check', (e) => {
            let interval = setTimeout(() => this.updateTax(), 150);

        });
        $('body').on('change', '#create_payment_subscription #tax_percent', function(e) {
            if ($(this).val()>0) {
                let tax = parseInt($('#create_payment_subscription #payment_total').val())*parseInt($('#tax_percent').val())/100;
                $('.tax_total_field').text('$'+tax);
            }
        });
        /* $('body').on('change', '#create_payment_subscription select[name="tips"]', (e) => {
                $('.tips_total_field').text('$'+parseFloat($(e.target).val()).toFixed(2));
                this.updateTax();
                this.updateTotal();
        }); */

        $('body').on('click', '#create_payment_subscription .apply_tax', ()=> {
            let interval = setTimeout(() => this.updateTax(), 150);
        });

        $('body').on('load', '#create_payment_subscription .custom-checkbox', () => {
            this.updateTax();
            this.updateTotal();
        });
    },

    updateTax(){

        if ($('#create_payment_subscription #payment_total').val()>0 && $('#tax_percent').val()>0) {
            let tax = parseInt($('#create_payment_subscription #payment_total').val())*parseInt($('#tax_percent').val())/100;
            $('.tax_total_field').text('$'+tax.toFixed(2));
        }else{
            $('.tax_total_field').text('$0');
        }
    },

    updateTotal(){
        let final_total = 0;
        if ($('#payment_total').val() >=0) {
            let tax = 0;
            let tips = 0;
            if (!$('.tax_total_field').parent().hasClass('d-none')) {
                tax = parseFloat($('.tax_total_field').text().replace('$',''));
            }
            let sub_total = parseFloat($('.sub_total_field').text().replace('$',''));
            final_total = sub_total + tax;
        }

        $('.final_total_field').text('$'+parseFloat(final_total).toFixed(2));
    },

    initPagination(){
        if (window.location.pathname == '/payment-subscriptions') {
            let section = new Section('payments-subscriptions', true);
            section.show();
        }
    },

    viewDetailsForm(){
        $('body').on('click', '.view_payment_subscriptions_details_btn',(e) => {
            e.preventDefault();
            if (typeof($(e.target).data('id')) == 'undefined') {
                return;
            }
            let data = {
                id: $(e.target).data('id'),
                type: 'payment-subscription',
            }
            $.ajax({
                type: 'GET',
                url: '/services-management/categories/get-additional-form',
                data: data,
                success: (response) => {
                    $('#form-container').html(response);
                    $('#payment-subscription-details-modal').modal('show');
                },
                error: (response) => {
                    console.log(response);
                },
            });
        });
    },

    changeTaxForServiceListners(){
        $('select[name="service"]').off();
        $('select[name="service"]').on('change', (e)=>{
            this.getDataForService($(e.target).val());
        });
    },

    getDataForService(service_id){
        $.ajax({
            method: 'POST',
            url: `/payment-subscriptions/${service_id}/get-tax`,
            success: (response)=>{
                this.updateFormOnNewData(response);
            },
            error: (response) =>{
                console.log(response);
            }
        });
    },

    updateFormOnNewData(data){
        if (data.requires_payment) {
            $('.sub_total_field').parent().removeClass('d-none');
            if (!data.tax_exempt) {
                if (data.tax && data.tax.percent) {
                    $('#tax_percent').val(data.tax.percent);
                    $('.tax_total_field').parent().removeClass('d-none');
                }
            }else{
                $('.tax_total_field').parent().addClass('d-none');
                $('#tax_percent').val('');
            }
            this.updateTax();
        }else{
            $('.sub_total_field').parent().addClass('d-none');
            $('.tax_total_field').parent().addClass('d-none');
            $('#tax_percent').val('');
        }
        this.updateTotal();
    }
}
